import type { InputHTMLAttributes } from 'react';
import { IconSearch } from '../icons';

/** Toolbar search — design-language §3/§5: leading icon, pl-8, fixed comfortable width. */
export function SearchInput({
  className = '',
  ...props
}: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div className={`relative ${className}`}>
      <IconSearch
        size={16}
        className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground"
      />
      <input
        type="search"
        className="h-10 w-full rounded-[var(--radius)] border border-border bg-surface pl-8 pr-3 text-sm text-text outline-none placeholder:text-muted-foreground focus-visible:border-brand sm:w-[280px]"
        {...props}
      />
    </div>
  );
}
